import { Header } from "@/components/Header";
import { ProfileSkeleton } from "@/components/shared";
import { ProviderPageShell } from "../provider-page-shell";

export function ProviderLoadingSkeleton() {
    return (
        <ProviderPageShell>
            <Header className="hidden md:block bg-maltese-white" />
            <div className="pt-23.25 hidden md:block" />
            <ProfileSkeleton />
        </ProviderPageShell>
    );
}
